import { createSlice } from '@reduxjs/toolkit';
import { CompanyList, MemberList, RequestWithdrowal } from '../api/DirectoryApi';
import WithdrawalForm from '../../components/Business_Impact/RequestWithdrawal';

const initialState = {
  CompanyData: [],
  MemberData: [],
  WithdrawalData: [],
  loading: false,
};

export const DirectorySlice = createSlice({
  name: 'DirectorySlice',
  initialState,
  reducers: {},
  extraReducers: (builder) => {

    builder.addCase(CompanyList.pending, (state) => {
      state.loading = true;
    })
    builder.addCase(CompanyList.fulfilled, (state, action) => {
      state.CompanyData = action.payload.data;
      state.loading = false;
    })
    builder.addCase(CompanyList.rejected, (state) => {
      state.loading = false;
    });

    // slice for memberlist
    builder.addCase(MemberList.pending, (state) => {
      state.loading = true;
    })
    builder.addCase(MemberList.fulfilled, (state, action) => {
      state.MemberData = action.payload.data;
      state.loading = false;
    })
    builder.addCase(MemberList.rejected, (state) => {
      state.loading = false;
    });

    // slice for requestWithdrowel
    builder.addCase(RequestWithdrowal.pending, (state) => {
      state.loading = true;
    })
    builder.addCase(RequestWithdrowal.fulfilled, (state, action) => {
      state.WithdrawalData = action.payload.data;
      state.loading = false;
    })
    builder.addCase(RequestWithdrowal.rejected,(state) => {
      state.loading = false;
    })

  },
});



export default DirectorySlice.reducer;
